<template>
  <div class="p-6">
    <table class="table ltr">
      <thead>
        <tr>
          <th>Onwer</th>
          <th>Created At</th>
          <th>Designator</th>
          <th>Comment</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="loading">
          <td colspan="4">
            <div class="is-flex is-justify-content-center mt-6">
              <div class="loading"></div>
            </div>
          </td>
        </tr>
        <tr v-else v-for="stat in stats" :key="stat.id">
          <td>{{ stat.owner }}</td>
          <td>{{ $moment(stat.created_at).format('DD/MM/YYYY mm:hh') }}</td>
          <td>{{ stat.designator }}</td>
          <td v-if="stat.designator == 'time_exceeded_alert'">
            {{ stat.content }}
          </td>
          <td v-else></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ModalDesignatedPositionFeedConformation',
  props: {
    position: {
      type: Object
    }
  },
  data () {
    return {
      loading: true,
      stats: []
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      const alerts = await this.$network_utils.getAllAlerts({
        current_resource_type: 'Position',
        current_resource_id: this.position.id
      })
      const ids = alerts.map((alert) => alert.id)
      this.stats = await this.$network_utils.getStats({
        current_resource_type: 'Alert',
        current_resource_id: ids
      })
      this.loading = false
    }
  }
}
</script>
